import { FormControlLabel, Checkbox } from './MyCustomFile';

export const MyCheckbox = ({ name, label, checked, onChange, disabled }) => {
    return (
        <FormControlLabel
            control={<Checkbox name={name} checked={Boolean(checked)} onChange={onChange} disabled={disabled || false} />}
            label={label}
        />
    );
}